import { Route } from "react-router";
import { ProtectedRoute } from "./ProtectedRoute";
import MarketingMaterialsLandingPage from "../features/MarketingMaterials/pages/MarketingMaterialsLandingPage.tsx";
import { MarketingMaterialsDetailsPage } from "features/MarketingMaterials/pages/ItemDetails/MarketingMaterialsDetailsPage.tsx";
import { ViewCartPage } from "features/MarketingMaterials/pages/Checkout/ViewCartPage.tsx";
import { CartShippingDetailsPage } from "features/MarketingMaterials/pages/Checkout/CartShippingDetailsPage.tsx";
import { ReviewCartPage } from "features/MarketingMaterials/pages/Checkout/ReviewCartPage.tsx";
import React from "react";
import { CartConfirmationPage } from "features/MarketingMaterials/pages/Checkout/CartConfirmationPage.tsx";
import { UserNavigationGroup, UserRole } from "../types/declarations/enums.ts";
import { PendingCampaignsPage } from "../features/MarketingMaterials/pages/PendingCampaigns/PendingCampaignsPage.tsx";
import { CampaignShippingPage } from "../features/MarketingMaterials/pages/CampaignShipping/CampaignShippingPage.tsx";

export const MarketingMaterialsRoutes = ProtectedRoute({
	featureFlag: "marketingMaterialsEnabled",
	path: "marketing-materials",
	blackListNavGroupWithRoles: {
		[UserNavigationGroup.HOME_DEPOT]: Object.values(UserRole).filter((role) => role !== UserRole.USER),
		[UserNavigationGroup.MENARDS]: Object.values(UserRole).filter((role) => role !== UserRole.USER),
		[UserNavigationGroup.LOWES]: Object.values(UserRole).filter((role) => role !== UserRole.USER)
	},
	children: (
		<>
			<Route
				index
				element={<MarketingMaterialsLandingPage />}
			/>
			<Route
				path="items/:productId"
				element={<MarketingMaterialsDetailsPage />}
			/>
			<Route
				path="view-cart"
				element={<ViewCartPage />}
			/>
			<Route
				path="shipping-details"
				element={<CartShippingDetailsPage />}
			/>
			<Route
				path="review-cart"
				element={<ReviewCartPage />}
			/>
			<Route
				path="confirmation"
				element={<CartConfirmationPage />}
			/>
			<Route
				path="pending-campaigns"
				element={<PendingCampaignsPage />}
			/>
			<Route
				path="campaign-shipping"
				element={<CampaignShippingPage />}
			/>
		</>
	)
});
